import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import app from "@/main";
import { isUserLoggedIn } from '@/utils/auth'

// Import Routes
import * as ROUTES from "./routes";

// Modules Route 
import authRoutes from "./route_modules/auth";
import dashboardRoutes from "./route_modules/dashboard";
import customerRoutes from "./route_modules/customer"
import transactionsRoutes from "./route_modules/transactions"
import settingsRoutes from "./route_modules/settings"
import giftcardRoutes from "./route_modules/giftcard"
import workforceRoutes from "./route_modules/workforce"
import appManagerRoutes from "./route_modules/appManager"
import cryptoRoutes from "./route_modules/crypto";
import rewardsRoutes from "./route_modules/reward";

Vue.use(VueRouter)

const routes = [
  ...authRoutes,
  ...customerRoutes,
  ...cryptoRoutes,
  ...appManagerRoutes,
  ...dashboardRoutes,
  ...settingsRoutes,
  ...giftcardRoutes,
  ...rewardsRoutes,
  ...transactionsRoutes,
  ...workforceRoutes,
  {
    // catch all 404 - define at the very end
    path: "*",
    component: () => import("../modules/404.vue")
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const verifyPermissions = ({ to, next }) => {

  const userPermissions = store.state.userDetails.permissions;
  if (to.meta.permissions && to.meta.permissions.length > 0) {
    let isAllowed = userPermissions.some(p => to.meta.permissions.includes(p))
    if (!isAllowed) return next('/dashboard')
  }

};

const checkProfileStatus = ({ to, next }) => {
  if (!store.state.userDetails.profile.firstname && !store.state.userDetails.profile.lastname && to.path !== ROUTES.PROFILE) {
    next({
      path: ROUTES.PROFILE,
      query: { redirect: to.fullPath }
    })
    app.$store.dispatch('toast', {
      message: "Please update your profile for administrative purposes",
      variant: 'success'
    })
  }

};

const checkLoginStatus = async (checks) => {
  if (isUserLoggedIn()) {
    verifyPermissions(checks);
    checkProfileStatus(checks);
    checks.next();
  }
  else {
    checks.next({
      path: '/',
      query: { redirect: checks.to.fullPath },
    });
  }
}





// Route Guards before every navigation
router.beforeEach((to, _from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    checkLoginStatus({ to, _from, next })
  } else {
    next();
  }
});

router.afterEach((to) => {
  document.title = `${to.meta.title || "ADMIN"} | Dtunes`;
});

export default router
